<template>
	<div id="Flux360">
		<div class="render-level">
			<RenderController/>
			<Renderer class="full-screen">
				<PanoramaScene/><!-- Add "debug" to the tag to enable debug mode -->
			</Renderer>
		</div>
		<div class="ui-level" style="background: transparent; display: none; pointer-events: none;">
			<!--PanoramaSceneUI /-->
		</div>
	</div>
</template>

<style>
#Flux360{
	transition: opacity .2s ease-in;
}
.full-screen {
	height: 100% !important;
	width: 100% !important;
}

.render-level {
	position: absolute;
	width: 100%;
	height: 100%;
}

.ui-level {
	position: absolute;
	right: 0px;
	top: 0px;
	width: 20% !important;
	height: 100% !important;
}
.title {
    font-size: 1em !important;
    text-align: left !important;
    line-height: 1.2 !important;
    margin-bottom: 0px !important;
}
</style>

<script>
import Renderer from "@/components/babylonjs/Renderer";
import PanoramaScene from "./PanoramaScene";
import RenderController from "@/components/babylonjs/RenderController";
import PanoramaSceneUI from "./PanoramaSceneUI";
import MediaManager from "@/api/MediaManager";
import {Media} from "@/store/flux360/MediaManagerDataTypes";
import {errorHandler} from "@/store/error-handler";
import {mapGetters, mapState} from 'vuex'

export default {
	components: {Renderer, PanoramaScene, PanoramaSceneUI, RenderController},
	data: () => ({
		queryParameterSituationID: "situationID",
		queryParameterSessionID: "sessionID",
		automaticTitle: true,
        firstTitleChange: true
	}),
	computed: {
		...mapGetters(['localUser', 'events', 'commands', 'users', 'panoramaTour', 'appVersion']),
    	...mapState(['openTokTest']),
		myUsers() {
			return this.$store.state.users;
		}
	},
	timers: {
		housekeeping: { time: 1000, autostart: true, repeat: true },
		networkSync: { time: 100, autostart: true, repeat: true }
    },
	created: function () {
		console.log("***********************************************");
		console.log("Flux360::Version " + this.$store.getters.appVersion);
		console.log("Flux360::Starting up");
		this.decodeURL();

		// Adding watches to the store...
		/*
		this.$store.watch((state, getters) => getters.localUser, (oldValue, newValue) => {
			if( newValue && newValue.ifShouldSync() ) {
				this.$store.dispatch('broadcastUserUpdate', newValue.getSharedProperties());
				newValue.resetShouldSync();  
			}
		}, { deep: true });		
		*/
		
		this.$store.watch((state, getters) => getters.currentSituation, (newValue, oldValue) => {
			this.handleSituationChange( oldValue, newValue );
		});	

		/*
		this.$store.watch((state, getters) => getters.localUser, (oldValue, newValue) => {
    		console.log("Flux360::EventHandling - localUser old: " + JSON.stringify(oldValue) + " new: " + JSON.stringify(newValue));
		}, { deep: true });
		this.$store.watch((state) => state.flux360.events, (oldValue, newValue) => {
    		console.log("Flux360::EventHandling - events old: " + JSON.stringify(oldValue) + " new: " + JSON.stringify(newValue));
		}, { deep: true });
		*/

		window.onpopstate = this.onPopState.bind(this);

		// Adding default media
		// this.$store.commit('addMedia', MediaManager.createFromJSON(
		// 		{ 
		// 			id: MediaManager.defaultTransitionTextureID,
		// 			idName: MediaManager.defaultTransitionTextureID,
		// 			type: Media.MediaType.Texture,
		// 			filename: "flux_transition.png",
		// 			url: "./flux/flux_transition.png",
		// 			isReadable: 'false',
		// 			contentId: -1,
		// 			mipmapping: 'true',
		// 			linearColorSpace: 'false',
		// 			filterMode: 'BiLinear',
		// 			ansioLevel: 1,
		// 			width: 100,
		// 			height: 100,
		// 			alphaIsTransparency: 'false',
		// 			fileSize: 642.620
		// 		})
		// );
		// const zip = '66816'; // Halle TEST
		// const zip = '64277';	// Original
		// const zip = '80098'; //Emden Leer
		// const zip = '86153'; //Cordes
		// const zip = '132099'; // Test Tour Braunschweig

		// const zip = '103280'; // Vigour Messestand
		// const zip = '123885'; // Museum Tour
		// const zip = '96359'; // Cosmo Messestand
		// const zip = '135630'; // DMG Mori
		// const zip = '133616'; // Venjakob Aero
		// const zip = '136793'; // Venjakob Technikum
		// const zip = '142241'; // Automotive Tour
		
		this.$store.dispatch('loadLocalConfiguration').then( () => {
			console.log("Loading Panorama");
			if( this.$store.state.flux360.config.panoramaTourZIP ) {
				let zip = this.$store.state.flux360.config.panoramaTourZIP;
				console.log("Loading panorama tour with ID " + zip )
				this.$store.dispatch('loadPanoramaTour', {zip, preview: false})
					.then(() => {
						console.log("Data is loaded!");
					})
					.catch(errorHandler);
			}
		});

		console.log("Flux360::Setup complete");
	},
	methods: {
		onPopState() {
			//alert("onPopState: location: " + document.location + ", state: " + JSON.stringify(event.state));
			//console.log("onPopState: location: " + document.location + ", state: " + JSON.stringify(event.state));
			this.$store.commit( 'handleGotoSituationTransition',  
                {
					situationID: event.state.situationID, 
					rotation: event.state.rotation ? event.state.rotation : undefined
                }); 			
		},
		decodeURL() {
			let originalURL = new URL(window.location);
        	let search_params = originalURL.searchParams;
        	if( search_params.get(this.queryParameterSituationID) ) {
            	// Now we know that we may have to go to a certain room...
				this.$store.commit( 'overwriteStartSituationID',  { situationID: search_params.get(this.queryParameterSituationID) } );
        	}

			if( search_params.get(this.queryParameterSessionID) ) {
				this.$store.commit( 'setSessionID',  "HF_Group_"+search_params.get(this.queryParameterSessionID) );
        	}
			
		},
		handleSituationChange( oldValue, newValue ) {
			const situation = newValue;
			if( !situation )
				return;

			if(this.firstTitleChange === true ){
            	if ( (document.title !== null && document.title.value === "") || (document.title==="Flux 360�") ){
                	this.automaticTitle = true;
            	}
            	else{
                	this.automaticTitle = false;
            	}
            	this.firstTitleChange = false;
        	}
        	if(this.automaticTitle === true){
            	if(this.panoramaTour.getName() !== "unnamed"){
                	document.title= this.panoramaTour.getName();
            	}
            	if(situation.getName() !== "unnamed"){
	                document.title += situation.getName();
            	} 
            	if( (this.panoramaTour.getName() === "unnamed") && (situation.getName() === "unnamed")){
	                document.title = "Flux Panoramatour";
            	}
            	console.log("Title: " + document.title);
        	}
        
			let flux360State = { situationID: situation.getID() };
        	let originalURL = new URL(window.location);
			let search_params = originalURL.searchParams;
			//console.log("Handle Situation Change to " + situation.getID() + " Situation ID in query is " + search_params.get(this.queryParameterSituationID));
        	if( search_params.get(this.queryParameterSituationID) && search_params.get(this.queryParameterSituationID) == situation.getID() )
            	return;
        	// new value of "id" is set to "101"
        	search_params.set(this.queryParameterSituationID, situation.getID());
        	// change the search property of the main url
        	originalURL.search = search_params.toString();
			let newURL = originalURL.toString();
			//console.log("Pushing " + situation.getName() + " = " + situation.getID());
        	window.history.pushState(flux360State, situation.getName(), newURL);
		},
		housekeeping() {
			// Removing outdated events...
			const timestamp = Date.now();
			let myEvents = this.events.slice();
			myEvents.forEach( x => {
				// Check if it has timed out...
				// console.log("- Event " + x.getType() + " started " + x.getTime() + " with duration " + x.getDuration());
				if( x.getTime() + x.getDuration() < timestamp ) {
					// console.log(" timedout and will be removed");
					this.$store.commit("removeEventByID", { id: x.getID() });
				}
			});
		},
		// Synchronizes the local state over the network...
		networkSync() {
			if( this.localUser && this.localUser.ifShouldSync() ) {
				this.$store.dispatch('broadcastUserUpdate', this.localUser.getUpdatedProperties()).then( 
					x => { 
						//console.log("Synchronized " + JSON.stringify(this.localUser.getUpdatedProperties() ));
						this.localUser.resetShouldSync(); 
					} 
				);
			}
		}
	}
}
</script>